var map = {
	"./en/404.json": [
		74438,
		4438
	],
	"./en/500.json": [
		50933,
		933
	],
	"./en/affiliate.json": [
		71436,
		1436
	],
	"./en/auth.json": [
		31974,
		1974
	],
	"./en/banner.json": [
		26208,
		6208
	],
	"./en/best-rates-component.json": [
		78297,
		8297
	],
	"./en/blog.json": [
		82569,
		2569
	],
	"./en/common.json": [
		83147,
		3147
	],
	"./en/compare.json": [
		96824,
		6824
	],
	"./en/cryptos-component.json": [
		48908,
		8908
	],
	"./en/exchange-why.json": [
		49452,
		9452
	],
	"./en/faq.json": [
		25257,
		5257
	],
	"./en/footer.json": [
		9170,
		9170
	],
	"./en/header.json": [
		96535,
		6535
	],
	"./en/homepage.json": [
		66516,
		6516
	],
	"./en/hot-deals.json": [
		27697,
		7697
	],
	"./en/how-to-stake.json": [
		66601,
		6601
	],
	"./en/newsletter.json": [
		10514,
		514
	],
	"./en/share-and-earn.json": [
		2183,
		2183
	],
	"./en/stake.json": [
		30979,
		979
	],
	"./en/subscribe.json": [
		37632,
		7632
	],
	"./en/wallet_page.json": [
		7401,
		7401
	],
	"./fr/404.json": [
		24377,
		4377
	],
	"./fr/500.json": [
		12225,
		2225
	],
	"./fr/affiliate.json": [
		81274,
		1274
	],
	"./fr/auth.json": [
		12459,
		2459
	],
	"./fr/banner.json": [
		16584,
		6584
	],
	"./fr/best-rates-component.json": [
		8106,
		8106
	],
	"./fr/blog.json": [
		10293,
		293
	],
	"./fr/common.json": [
		97038,
		7038
	],
	"./fr/compare.json": [
		75868,
		1692
	],
	"./fr/cryptos-component.json": [
		92900,
		2900
	],
	"./fr/exchange-why.json": [
		4465,
		4465
	],
	"./fr/faq.json": [
		43525,
		3525
	],
	"./fr/footer.json": [
		56276,
		6276
	],
	"./fr/header.json": [
		24929,
		4929
	],
	"./fr/homepage.json": [
		94377,
		3690
	],
	"./fr/hot-deals.json": [
		92297,
		2297
	],
	"./fr/how-to-stake.json": [
		80634,
		634
	],
	"./fr/newsletter.json": [
		19694,
		9694
	],
	"./fr/share-and-earn.json": [
		89463,
		9463
	],
	"./fr/stake.json": [
		29714,
		9714
	],
	"./fr/subscribe.json": [
		42911,
		2911
	],
	"./fr/wallet_page.json": [
		66117,
		6117
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7535;
module.exports = webpackAsyncContext;